import React, { useRef, useState, useEffect  } from 'react';

import { OverlayPanel } from 'primereact/overlaypanel';
import './atlas-Perspectives.scss';

interface DropdownProps {
  value: any;
  options: any[];
  onChange: (e: { value: string }) => void;
  placeholder?: string;
  optionLabel?: string;
  filter?: boolean;
  className?: string;
  valueTemplate?: (option: string) => JSX.Element;
  itemTemplate?: (option: string) => JSX.Element;
  disabled?: boolean;
}

const AtlasPerspectives: React.FC<DropdownProps> = ({
  value,
  options,
  onChange,
  optionLabel = "label",
  filter = false,
  className = "",
  disabled = false,
}) => {

  const [searchQuery, setSearchQuery] = useState(""); // State for the search query
  const [filteredOptions, setFilteredOptions] = useState(options); // State for filtered options
  const overlayPanelRef = useRef<OverlayPanel>(null);
// Update filtered options when search query or options change
useEffect(() => {
  if (searchQuery.trim() === "") {
    setFilteredOptions(options); // Show all options if search query is empty
  } else {
    const filtered = options.filter(option =>
      option[optionLabel].toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredOptions(filtered);
  }
}, [searchQuery, options, optionLabel]);

  const handleItemClick = (option: any) => {
    // Trigger onChange when an option is selected
    onChange({ value: option.value });
    overlayPanelRef.current?.hide(); // Hide the dropdown after selecting
  };
  const handleIconClick = (event: React.MouseEvent) => {
    // Show or toggle the OverlayPanel dropdown
    overlayPanelRef.current?.toggle(event);
  };
  return (
    <div className="perspectives-container">
      {/* Icon to trigger dropdown */}


        <ul className={`dropdown-items atlas-perpectives pt-0 p-4 ${className}`}>
          {/* <li>
            <span className='user-border'>            
              <i className="mt-1" style={{
              width: '24.632px',
              height: '24.632px',
              background: 'url("data:image/svg+xml,%3Csvg%20width%3D%2229%22%20height%3D%2228%22%20viewBox%3D%220%200%2029%2028%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_850_102397)%22%3E%3Cpath%20d%3D%22M14.6874%2026.5989C21.7247%2026.5989%2027.4294%2020.8942%2027.4294%2013.8568C27.4294%206.81956%2021.7247%201.11475%2014.6874%201.11475C7.65013%201.11475%201.94531%206.81956%201.94531%2013.8568C1.94531%2020.8942%207.65013%2026.5989%2014.6874%2026.5989Z%22%20stroke%3D%22%23377FC4%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3Cg%20clip-path%3D%22url(%23clip1_850_102397)%22%3E%3Cpath%20d%3D%22M21.1875%2017.3569V19.3569C21.1875%2019.6221%2021.0821%2019.8765%2020.8946%2020.064C20.7071%2020.2515%2020.4527%2020.3569%2020.1875%2020.3569H18.1875%22%20stroke%3D%22%23377FC4%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3Cpath%20d%3D%22M18.1875%207.35693H20.1875C20.4527%207.35693%2020.7071%207.46229%2020.8946%207.64983C21.0821%207.83736%2021.1875%208.09171%2021.1875%208.35693V10.3569%22%20stroke%3D%22%23377FC4%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3Cpath%20d%3D%22M8.1875%2010.3569V8.35693C8.1875%208.09171%208.29286%207.83736%208.48039%207.64983C8.66793%207.46229%208.92228%207.35693%209.1875%207.35693H11.1875%22%20stroke%3D%22%23377FC4%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3Cpath%20d%3D%22M11.1875%2020.3569H9.1875C8.92228%2020.3569%208.66793%2020.2515%208.48039%2020.064C8.29286%2019.8765%208.1875%2019.6221%208.1875%2019.3569V17.3569%22%20stroke%3D%22%23377FC4%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3Cpath%20d%3D%22M14.6875%2013.3569C15.7921%2013.3569%2016.6875%2012.4615%2016.6875%2011.3569C16.6875%2010.2524%2015.7921%209.35693%2014.6875%209.35693C13.5829%209.35693%2012.6875%2010.2524%2012.6875%2011.3569C12.6875%2012.4615%2013.5829%2013.3569%2014.6875%2013.3569Z%22%20stroke%3D%22%23377FC4%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3Cpath%20d%3D%22M18.4909%2017.8568C18.2325%2017.0511%2017.725%2016.3484%2017.0415%2015.8498C16.358%2015.3512%2015.5338%2015.0825%2014.6878%2015.0825C13.8418%2015.0825%2013.0176%2015.3512%2012.3341%2015.8498C11.6506%2016.3484%2011.1431%2017.0511%2010.8848%2017.8568H18.4909Z%22%20stroke%3D%22%23377FC4%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_850_102397%22%3E%3Crect%20width%3D%2227.4444%22%20height%3D%2227.4444%22%20fill%3D%22white%22%20transform%3D%22translate(0.964844%200.134277)%22/%3E%3C/clipPath%3E%3CclipPath%20id%3D%22clip1_850_102397%22%3E%3Crect%20width%3D%2214%22%20height%3D%2214%22%20fill%3D%22white%22%20transform%3D%22translate(7.6875%206.85693)%22/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")',
              backgroundSize: 'contain',
              display: 'inline-block',
              backgroundRepeat: 'no-repeat',
            }} /></span>

            <IconField iconPosition="right">
            <InputText
                className="perspectives-search"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)} // Update search query
              />
              <InputIcon className="pi pi-search"> </InputIcon>
            </IconField>
          </li> */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <li key={index} onClick={() => handleItemClick(option)}>
                <i className="subject-icon mr-2" />
              <span className='persp-label'>{option[optionLabel] || option.label}</span>
            </li>
          ))
          ) : (
            <li className="no-results">No results found</li>
          )}
        </ul>

    </div>
  );
};

export default AtlasPerspectives;
